import { PROBLEM_TYPES } from '@rythmo/shared';
import { en } from './en.js';
import { ro } from './ro.js';
const catalogues = { ro, en };
export function messages(locale) {
    return catalogues[locale];
}
const known = new Set(PROBLEM_TYPES);
/**
 * What to tell a person about a refusal's `type`. Takes any string, because
 * `ApiProblem.type` may be `about:blank` or a type newer than this build.
 */
export function problemMessage(type, locale) {
    const catalogue = messages(locale);
    return known.has(type) ? catalogue.problems[type] : catalogue.unknownProblem;
}
//# sourceMappingURL=messages.js.map